import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

const STORAGE_KEY = 'currentLang';
const SUPPORTED_LANGUAGES = ['fr', 'en'] as const;
type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];
const DEFAULT_LANGUAGE: SupportedLanguage = 'fr';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  constructor(private translate: TranslateService) {}

  init(): void {
    this.translate.setDefaultLang(DEFAULT_LANGUAGE);
    const stored = localStorage.getItem(STORAGE_KEY);
    const lang = this.isSupported(stored) ? stored : DEFAULT_LANGUAGE;
    this.translate.use(lang);
  }

  setLanguage(lang: SupportedLanguage): void {
    this.translate.use(lang);
    localStorage.setItem(STORAGE_KEY, lang);
  }

  getCurrentLanguage(): string {
    return this.translate.currentLang || DEFAULT_LANGUAGE;
  }

  private isSupported(value: string | null): value is SupportedLanguage {
    return SUPPORTED_LANGUAGES.includes(value as SupportedLanguage);
  }
}
